<template>
  <v-row justify="center">
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-card-title>{{ titulo }}</v-card-title>
        <v-card-text style="color: black">
          <p> Digite a palavra chave "<b>{{ palavraChave }}</b>" {{ mensagemFinal }}</p>
          <v-text-field
              v-model="textoPalavraChave"
              outlined
              dense
              name="textoConfirmacao"
              :placeholder="placeholder"
              v-validate="{required: true}"
              :error-messages="errors.collect('textoConfirmacao')">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="cancelar" :color="corCancelar">{{ textCancelar }}</v-btn>
          <v-btn @click="confirmar" text :color="corConfirmar">{{ textConfirmar }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name: 'ConfirmTextModal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        palavraChave: {
            type: String,
            required: true
        },
        mensagemFinal: {
            type: String,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: true
        },
        titulo: {
            type: String,
            default: 'Atenção!'
        },
        textCancelar: {
            type: String,
            default: 'Voltar'
        },
        textConfirmar: {
            type: String,
            default: 'Confirmar'
        },
        corCancelar: {
            type: String,
            default: 'black'
        },
        corConfirmar: {
            type: String,
            default: 'red'
        },
        maxWidth: {
            type: Number,
            default: 400
        },
        placeholder: {
            type: String,
            default: 'Escreva a palavra de confirmação'
        }
    },
    data() {
        return {
            textoPalavraChave: null,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('modalConfirmTextAcaoVoltar')
        },
        async confirmar() {
            if (await this.validarDadosFormulario()) {
                if (this.textoPalavraChave.toUpperCase() !== this.palavraChave.toUpperCase()) {
                    this.mostrarNotificacaoErro('Digite a palavra chave corretamente!')
                    return
                }
                this.model = false
                this.$emit('modalConfirmTextAcaoConfirmar')
            }
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

</style>